<template>
  <div class="container">
    <div class>
      <div class="mt-100 container-style mb-100">
        <studyFeatureHeader></studyFeatureHeader>
        <div class="p-20">
          <div class="visit-container">
            <div v-if="!addEditVisit && !onEdit" class="alreadyAddedVisits">
              <div v-if="countrySpecificStudyFeatures" class="mt-26">
                <div class="mb-10 font-weight-bold">
                  Which countries will Telehealth be available in?
                </div>
                <div class="mb-20 countries-toggle">
                  <div v-for="(country, keyIndex) in countrySpecificStudyFeatures.filter(countrySpecificStudyFeature => countrySpecificStudyFeature.active)" :key="keyIndex">
                    <label class="switch">
                      <input type="checkbox" v-model="country.isTelehealthEnabled" @change="toggleTHRecordingSettings()" />
                      <div class="slider round"></div>
                      <span class="country-name">{{ country.name }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="isTelehealthRecordingFeature">
                <div class="mb-10 font-weight-bold">
                  Will you allow recording features to be set on each telehealth visit?<span
                    v-b-popover.hover="
                      'Optional feature that allows audio and video recording on telehealth visits. Choose between allowing for all telehealth visits (both scheduled and On Demand) or provide the option to configure at the individual telehealth visit level. If either option is configured, a permission request to record will be sent to the participant via the app and will not be recorded unless the participant gives consent.'
                    "
                    class="ml-5 p-r img-wrap"
                    ><img src="static/img/telehealth/Icon.png"
                  /></span>
                </div>
                <div class="visit-recording mb-0">
                  <div class="pb-5">
                    <input type="checkbox" class="checkbox" v-model="THvisitRecordingState.studyLevel" @change="mutualExclusive('studyLevel')" />
                    <label for="checkbox" :class="{ disabled: !THvisitRecordingState.studyLevel }" class="control-label">Allow recording features for all telehealth visits</label>
                  </div>
                  <div class="pb-5">
                    <input type="checkbox" class="checkbox" @change="mutualExclusive('visitLevel')" v-model="THvisitRecordingState.visitLevel" />
                    <label for="checkbox" :class="{ disabled: !THvisitRecordingState.visitLevel }" class="control-label">Allow and configure recording features at each visit</label>
                  </div>
                </div>
                <div class="country-recording mb-0" v-if="THvisitRecordingState.studyLevel || THvisitRecordingState.visitLevel">
                  <div class="pb-5 display-inline-block">
                    <input type="radio" class="radio" :value="true" v-model="isAllowedInAllCountry" @change="toggleTHRecordingCountrySpecific()" id="allowedInAllCountry" />
                    <label for="allowedInAllCountry" class="control-label">Allowed in all countries</label>
                  </div>
                  <div class="pb-5 ml-20 display-inline-block">
                    <input type="radio" class="radio" :value="false" v-model="isAllowedInAllCountry" @change="toggleTHRecordingCountrySpecific()" id="allowedInSpecificCountry" />
                    <label for="allowedInSpecificCountry" class="control-label">Select countries to allow</label>
                  </div>
                  <div class="card ml-26" v-if="isAllowedInAllCountry == false">
                    <div class="m-0 country-wrapper">
                      <span v-for="(country, keyIndex) in countrySpecificStudyFeatures.filter(countrySpecificStudyFeature => countrySpecificStudyFeature.active)" :key="keyIndex" class="display-inline-block ml-16 country-list" :class="{ disabled: !country.isTelehealthEnabled }">
                        <input class="checkbox" :disabled="!country.isTelehealthEnabled" v-model="country.isTelehealthRecordingFeature" type="checkbox" />
                        <label class="checkbox-label checkbox-colour" :id="country - label">{{ country.name }}</label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-10 mt-15 font-weight-bold">
                Create visits by using milestones or custom frequency.
              </div>
              <div class="mb-20">
                <button class="btn btn-outline-primary boldBtn" @click="addNewVisit()">
                  Add a visit
                </button>
              </div>
              <hr class="mb-20" />
              <div v-if="existingVisits.length > 0">
                <div v-for="(v, key) in existingVisits" :key="key" class="mb-21">
                  <div class="row">
                    <div class="col-sm-5 col-lg-5">
                      <strong>{{ v.visitName }}</strong>
                    </div>
                    <div class="col-sm-5 col-lg-6">{{ v.schedules }}</div>
                    <div class="col-sm-2 col-lg-1 text-right">
                      <span class="link" @click="editVisit(v)">Edit</span>
                      <span class="edit-icon" @click="deleteVisit(v, key)">
                        <img src="static/img/econsent/collapse_consent.svg" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="noVisists">No telehealth visits added</div>
            </div>
            <schedulerComponent
              v-if="addEditVisit || onEdit"
              :options="{
                validateFor: 'telehealthv2',
                scheduler: telehealthVisit.scheduler,
                telehealthv2: true,
                telehealthVisitDTO: telehealthVisit.telehealthVisitDTO,
                notificationData: notificationData,
                isDataExist: isNotificationDataExist
              }"
              :THvisitRecordingState="THvisitRecordingState"
              class="schedulerSection"
              @exit="addEditDone"
            ></schedulerComponent>
          </div>

          <div class="pt-20">
            <span class="back_link" v-on:click="goBack()"> <i class="fa fa-chevron-left" aria-hidden="true"></i> Back </span>
          </div>
        </div>
        <div class="footerStyle">
          <div class="container">
            <div class="row" v-if="isStudySummary">
              <b-btn class="btn nextBtn float-left br-25" @click="cancelModify">Cancel modifying</b-btn>
              <b-btn class="btn br-25 disable-btn p-0 pt-5 mr-10" :to="{ name: 'study-summary', params: { studyId: studyId } }">Back to study summary</b-btn>
              <button class="btn br-25 continue-btn mr-10" v-on:click="validateScheduler()">
                Save and Continue
              </button>
            </div>
            <div class="row" v-if="!isStudySummary">
              <button class="btn br-25 disable-btn mr-10" v-on:click="skipForNow()">
                Skip for now
              </button>
              <button class="btn nextBtn br-25" v-on:click="validateScheduler()">
                Save and Continue
              </button>
            </div>
          </div>
        </div>
        <CancelModal ref="cancelConfirmation" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import studyFeatureHeader from "../common/study-features-header";
import schedulerComponent from "../common/telehealth-scheduler";
import CancelModal from "./cancel-modify-modal";
import swal from "sweetalert2";
import nprogress from "nprogress";

export default {
  name: "scheduler",
  data() {
    return {
      addEditVisit: false,
      existingVisits: [],
      studyId: null,
      studyData: {},
      surveyId: null,
      milestones: [],
      isAllowedInAllCountry: true,
      frequencies: [
        { type: "daily", title: "Daily", days: 1 },
        { type: "weekly", title: "Weekly", days: 7 },
        { type: "biweekly", title: "Every 2 Weeks", days: 15 },
        { type: "monthly", title: "Monthly", days: 30 },
        { type: "biannually", title: "Bi-annually", days: 180 },
        { type: "annually", title: "Annually", days: 360 }
      ],
      telehealthVisit: {
        scheduler: {
          type: "milestone",
          milestones: [],
          frequency: { type: null, title: null, days: null },
          startDay: null,
          endDay: null,
          completionWindow: null,
          reminders: [],
          callReminders: [],
          allowMultipleTimes: false,
          allowUntillDuration: false,
          isActivityOptional: false,
          duration: [{ startDay: null, endDay: null }]
        },
        telehealthVisitDTO: {
          title: this.visitTitle,
          sequence: 1,
          createdTime: new Date(),
          version: "1.0",
          status: "Initiated",
          useHTML: true
        }
      },
      eventOptionTypes: {
        2: [
          {
            value: "b-10-d",
            text: "10 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-7-d",
            text: "7 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-5-d",
            text: "5 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-2-d",
            text: "2 days before the appointment time",
            delayType: "before"
          },
          {
            value: "b-1-d",
            text: "1 day before the appointment time",
            delayType: "before"
          },
          {
            value: "b-2-h",
            text: "2 hours before the appointment time",
            delayType: "before"
          },
          {
            value: "b-1-h",
            text: "1 hour before the appointment time",
            delayType: "before"
          },
          {
            value: "b-45-m",
            text: "45 minutes before the appointment time",
            delayType: "before"
          },
          {
            value: "b-30",
            text: "30 min before the appointment time",
            delayType: "before"
          },
          {
            value: "b-15",
            text: "15 min before the appointment time",
            delayType: "before"
          },
          {
            value: "b-10",
            text: "10 min before the appointment time",
            delayType: "before"
          },
          {
            value: "b-5",
            text: "5 min before the appointment time",
            delayType: "before"
          },
          { value: 0, text: "At time of event" },
          {
            value: "a-5",
            text: "5 min after the appointment time (if call has not begun)",
            delayType: "after"
          },
          {
            value: "a-10",
            text: "10 min after the appointment time (if call has not begun)",
            delayType: "after"
          },
          {
            value: "a-15",
            text: "15 min after the appointment time (if call has not begun)",
            delayType: "after"
          },
          {
            value: "a-30",
            text: "30 min after the appointment time (if call has not begun)",
            delayType: "after"
          }
        ]
      },
      isStudySummary: JSON.parse(window.localStorage.getItem("thread-studySummary")),
      onEdit: false,
      isNotificationDataExist: false,
      countrySpecificStudyFeatures: null,
      THvisitRecordingState: { studyLevel: false, visitLevel: false },
      isTelehealthRecordingFeature: false,
      getPreviouslySavedData: {},
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      isTHSchedulerAutoSaveEnable: true
    };
  },
  components: { studyFeatureHeader, schedulerComponent, CancelModal },
  computed: {
    telehealthVisitObjChanged() {
      return this.$store.getters.getTelehealthVisitObjData;
    }
  },
  watch: {
    telehealthVisitObjChanged: {
      handler(val) {
        if (val.validatedFor === "telehealthv2") {
          this.addTelehealthVisit(val.telehealthVisitObj, val.autoSave);
        }
      }
    }
  },
  mounted() {
    const isSchedulerOpen = window.localStorage.getItem("isSchedulerOpen");

    // TODO : if visit id avialble; we need to open that visit in Edit mode and remove key from local storge
    if (isSchedulerOpen) {
      this.addNewVisit();
      window.localStorage.removeItem("isSchedulerOpen");
    }

    this.studyId = this.$route.params.studyId;
    this.surveyId = this.$route.params.surveyId;
    this.getStudyDetails();
    window.setTimeout(() => {
      const scrollableSection = window.document.getElementById("feature_menu_scroll");
      scrollableSection.scrollLeft += 500;
    }, 3000);

    this.startAutoSave();

    this.getExistingVisits();
    this.getCountrySpecificStudyFeatures();
    this.$root.$on("isAutoSaveTHScheduler", data => {
      this.isTHSchedulerAutoSaveEnable = data;
    });
  },
  methods: {
    addNewVisit() {
      this.addEditVisit = true;
      this.notificationData = [];
      this.telehealthVisit = {
        scheduler: {
          type: "milestone",
          milestones: [],
          frequency: { type: null, title: null, days: null },
          startDay: null,
          endDay: null,
          completionWindow: null,
          reminders: [],
          callReminders: [],
          allowMultipleTimes: false,
          allowUntillDuration: false,
          isActivityOptional: false,
          duration: [{ startDay: null, endDay: null }],
          activitySchedulingMode: "schedule"
        },
        telehealthVisitDTO: {
          title: this.visitTitle,
          sequence: 1,
          createdTime: new Date(),
          version: "1.0",
          status: "Initiated",
          useHTML: true,
          visitType: "Telehealth",
          extendAvailability: false,
          extendWindow: "",
          allowRecording: false,
          configFor: "participant"
        }
      };
      const setTelehealthVisitArrayObject = [];
      for (let i = 0; i <= 3; i++) {
        let visitType = "";
        if (i === 0) {
          visitType = "Telehealth";
        } else if (i === 1) {
          visitType = "In-person";
        } else if (i === 2) {
          visitType = "Homevisit";
        } else if (i === 3) {
          visitType = "Phonecall";
        }
        const obj = {
          visitType: visitType,
          selected: false
        };
        setTelehealthVisitArrayObject.push(obj);
      }
      this.telehealthVisit.telehealthVisitDTO.visitTypes = setTelehealthVisitArrayObject;
      this.isNotificationDataExist = false;

      if (this.THvisitRecordingState.studyLevel) {
        this.telehealthVisit.telehealthVisitDTO.allowRecording = true;
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    filteredCompletionWindowsForDisplay(completionWindows) {
      const newCompletion = {};

      Object.keys(completionWindows).forEach(key => {
        const newKey = Number(key) - Number(this.studyData.screeningDuration);
        newCompletion[newKey] = Number(completionWindows[key]);
      });

      return newCompletion;
    },
    editVisit(visit) {
      const self = this;
      this.$api.getVisitDetail(this.studyId, visit.visitId).then(
        response => {
          self.telehealthVisit.scheduler = response.body.scheduler;

          if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
            if (self.telehealthVisit.scheduler.milestones && self.telehealthVisit.scheduler.milestones.length > 0) {
              for (let i = 0; i < self.telehealthVisit.scheduler.milestones.length; i++) {
                self.telehealthVisit.scheduler.milestones[i] -= this.studyData.screeningDuration;
              }
              self.telehealthVisit.scheduler.completionWindows = this.filteredCompletionWindowsForDisplay(self.telehealthVisit.scheduler.completionWindows);
            }

            if (self.telehealthVisit.scheduler.duration && self.telehealthVisit.scheduler.duration.length > 0) {
              self.telehealthVisit.scheduler.duration.forEach(duration => {
                Object.keys(duration).forEach(key => {
                  if (duration[key] !== null) {
                    duration[key] = Number(parseInt(duration[key]) - this.studyData.screeningDuration);
                  }
                });
              });
            }
          }

          if (response.body.scheduler !== null) {
            self.notificationData = self.processNotification(self.telehealthVisit.scheduler);
          } else {
            self.notificationData = [];
          }
          self.telehealthVisit.telehealthVisitDTO = response.body.telehealthVisitDTO;
          if (this.THvisitRecordingState.studyLevel) {
            this.telehealthVisit.telehealthVisitDTO.allowRecording = true;
          }
          const selectedVisits = this.telehealthVisit.telehealthVisitDTO.visitType.split("|");
          self.getPreviouslySavedData = JSON.parse(JSON.stringify(self.telehealthVisit));
          const setTelehealthVisitArrayObject = [];
          for (let i = 0; i <= 3; i++) {
            let selectedFlag = false;
            let visitType = "";
            if (i === 0) {
              visitType = "Telehealth";
              if (selectedVisits.includes("Telehealth")) {
                selectedFlag = true;
              }
            } else if (i === 1) {
              visitType = "In-person";
              if (selectedVisits.includes("In-person")) {
                selectedFlag = true;
              }
            } else if (i === 2) {
              visitType = "Homevisit";
              if (selectedVisits.includes("Homevisit")) {
                selectedFlag = true;
              }
            } else if (i === 3) {
              visitType = "Phonecall";
              if (selectedVisits.includes("Phonecall")) {
                selectedFlag = true;
              }
            }
            const obj = {
              visitType: visitType,
              selected: selectedFlag
            };
            setTelehealthVisitArrayObject.push(obj);
          }
          if (this.telehealthVisit.telehealthVisitDTO.visitType === "bothVisitType") {
            setTelehealthVisitArrayObject[0].selected = true;
            setTelehealthVisitArrayObject[1].selected = true;
          }
          self.telehealthVisit.telehealthVisitDTO.visitTypes = setTelehealthVisitArrayObject;
          self.telehealthVisit.telehealthVisitDTO.configFor = response.body.telehealthVisitDTO.configFor === undefined || response.body.telehealthVisitDTO.configFor === null ? "participant" : response.body.telehealthVisitDTO.configFor;
          self.onEdit = true;
          nprogress.done();
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while fetching telehealth visits");
          nprogress.done();
        }
      );
    },
    toggleTHRecordingCountrySpecific() {
      this.countrySpecificStudyFeatures.forEach(c => {
        if (this.isAllowedInAllCountry && c.isTelehealthEnabled) {
          c.isTelehealthRecordingFeature = true;
        } else {
          c.isTelehealthRecordingFeature = false;
        }
      });
    },
    processNotification(notification) {
      let notificationArr = [];
      const self = this;
      if (notification.reminders && notification.reminders.length > 0) {
        notificationArr.push({
          eventType: 1,
          day: notification.reminders,
          message: notification.reminders[0].message,
          smsToggle: notification.reminders[0].smsToggle,
          emailToggle: notification.reminders[0].emailToggle,
          time: self.processTime(notification.reminders[0].time)
        });
        self.isNotificationDataExist = true;
      }

      if (notification.callReminders && notification.callReminders.length > 0) {
        notificationArr.push({
          eventType: 2,
          day: notification.callReminders,
          message: notification.callReminders[0].message,
          smsToggle: notification.callReminders[0].smsToggle,
          emailToggle: notification.callReminders[0].emailToggle,
          time: self.processTime(notification.callReminders[0].time)
        });
        self.isNotificationDataExist = true;
      }
      if (notification.siteTaskCallReminders && notification.siteTaskCallReminders.length > 0) {
        notificationArr.push({
          eventType: 2,
          day: notification.siteTaskCallReminders,
          message: notification.siteTaskCallReminders[0].message,
          smsToggle: notification.siteTaskCallReminders[0].smsToggle,
          emailToggle: notification.siteTaskCallReminders[0].emailToggle,
          time: {
            hh: notification.siteTaskCallReminders[0].occur[0].timeMinutes,
            A: "min",
            mm: 0
          },
          id: notification.siteTaskCallReminders[0].id
        });
        self.isNotificationDataExist = true;
      }
      if (!self.isNotificationDataExist) {
        return notificationArr;
      }
      if (notification.siteTaskCallReminders && notification.siteTaskCallReminders.length > 0) {
        notificationArr = self.SiteTaskprocessOccurranceStringAndCount(notificationArr);
      } else {
        notificationArr = self.processOccurranceStringAndCount(notificationArr);
      }
      return notificationArr;
    },
    processOccurranceStringAndCount(notificationArr) {
      let occurranceList = [];
      let telehealthReminders = [];
      const that = this;
      for (let i = 0; i < notificationArr.length; i++) {
        let list = null;
        switch (notificationArr[i].eventType) {
          case 1:
            occurranceList = [];
            telehealthReminders = [];
            list = notificationArr[i].day;
            for (let i = 0; i < list.length; i++) {
              occurranceList.push({
                text: this.getOccuranceText(list[i].day),
                value: list[i].day,
                smsToggle: list[i].smsToggle,
                emailToggle: list[i].emailToggle
              });
              telehealthReminders.push({
                text: this.getOccuranceText(list[i].day),
                value: list[i].day,
                smsToggle: list[i].smsToggle,
                emailToggle: list[i].emailToggle
              });
            }
            break;
          case 2:
            occurranceList = [];
            telehealthReminders = [];
            list = notificationArr[i].day;
            for (let i = 0; i < list.length; i++) {
              let v = 0;
              const time = list[i].time;
              const [value] = time.split(" ");
              if (list[i].time === "2 day") {
                v = "b-2-d";
              } else if (list[i].time === "1 day") {
                v = "b-1-d";
              } else if (list[i].time === "2 hour") {
                v = "b-2-h";
              } else if (list[i].time === "1 hour") {
                v = "b-1-h";
              } else if (list[i].time === "45 min") {
                v = "b-45-m";
              } else if (list[i].time === "60 min") {
                v = "b-1-h";
              } else if (list[i].time === "1440 min") {
                v = "b-1-d";
              } else if (list[i].time === "2880 min") {
                v = "b-2-d";
              } else if (list[i].time === "7200 min") {
                v = "b-5-d";
              } else if (list[i].time === "10080 min") {
                v = "b-7-d";
              } else if (list[i].time === "14400 min") {
                v = "b-10-d";
              } else if (list[i].time === "120 min") {
                v = "b-2-h";
              } else {
                v = list[i].delayType != null ? (list[i].delayType == "after" ? "a-" + value : "b-" + value) : 0;
              }
              const eventOptions = that.eventOptionTypes[2];
              eventOptions.filter(k => {
                if (v == k.value) {
                  telehealthReminders.push({
                    text: k.text,
                    value: value,
                    smsToggle: list[i].smsToggle,
                    emailToggle: list[i].emailToggle
                  });

                  occurranceList.push({
                    text: k.text,
                    value: k.value,
                    delayType: k.delayType,
                    smsToggle: list[i].smsToggle,
                    emailToggle: list[i].emailToggle
                  });
                }
              });
            }
            break;
        }
        notificationArr[i].telehealthReminders = telehealthReminders;
        notificationArr[i].occurranceList = occurranceList;
      }
      return notificationArr;
    },
    getOccuranceText(value) {
      let stringText = "";
      if (value == 0) {
        stringText = "At time of event";
      } else if (value < 0) {
        stringText = Math.abs(value) + " day(s) in advance";
      } else {
        stringText = value + " day(s) after (if not complete)";
      }
      return stringText;
    },
    processTime(time) {
      const [fhm, fa] = time.trim().split(" ");
      const [fhh, fmm] = fhm.split(":");
      return {
        hh: fhh,
        mm: fmm,
        A: fa
      };
    },
    deleteVisit(visit, index) {
      const self = this;
      swal({
        title: "Are you sure you want to delete this? \n You cannot undo this action.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        cancelButtonText: "Delete",
        confirmButtonText: "Cancel"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api.deleteTeleHealthVisitFact(this.studyId, visit.visitId).then(
            () => {
              self.existingVisits.splice(index, 1);
              nprogress.done();
              toastr.success(visit.visitName + " visit has been deleted");
            },
            error => {
              toastr.error(error.body ? error.body.message : "Error while deleting telehealth visits");
              nprogress.done();
            }
          );
        }
      });
    },
    getExistingVisits() {
      nprogress.start();
      this.$api.getTeleHealthVisitFact(this.studyId).then(
        response => {
          this.existingVisits = response.body;
          nprogress.done();
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting telehealth visits");
          nprogress.done();
        }
      );
    },
    addEditDone() {
      //This is the custom event handler which will be called from the child component
      this.addEditVisit = false;
      this.onEdit = false;
      this.getExistingVisits();
    },
    goBack() {
      if (!this.addEditVisit) {
        window.history.back();
      } else {
        this.addEditVisit = false;
      }
    },
    skipForNow() {
      const selectedFeatures = this.$store.getters.getSelectedFeatures;
      const featureIndex = _.findIndex(selectedFeatures, ["route", this.$route.name]);
      if (featureIndex === selectedFeatures.length - 1) {
        this.$router.push({ name: "features-library-final" });
      } else {
        this.$router.push({
          name: selectedFeatures[featureIndex + 1].route,
          params: { studyId: this.studyId }
        });
      }
    },
    cancelModify() {
      this.$refs.cancelConfirmation.show();
    },
    validateScheduler(autoSave = false) {
      if (this.addEditVisit) {
        if (!autoSave) {
          this.$store.dispatch("telehealthVisitAction", {
            validateFor: "telehealthv2"
          });
        } else {
          this.$store.dispatch("telehealthVisitAction", {
            validateFor: "telehealthv2",
            autoSave: autoSave
          });
        }
      } else {
        //Validate that atleast one country must have telehealth feature enabled or not
        if (
          _.chain(this.countrySpecificStudyFeatures)
            .filter({ isTelehealthEnabled: true })
            .size()
            .value() == 0
        ) {
          if (!autoSave) {
            toastr.error("At least one country must have Telehealth feature enabled.");
          }
          return;
        } else if (
          (this.THvisitRecordingState.studyLevel || this.THvisitRecordingState.visitLevel) &&
          this.isAllowedInAllCountry == false &&
          _.chain(this.countrySpecificStudyFeatures)
            .filter({ isTelehealthRecordingFeature: true })
            .size()
            .value() == 0
        ) {
          toastr.error("Please select at least one country.");
          return;
        } else {
          //Update the country specific telehealth status
          this.updateCountrySpecificStudyFeatures();
        }

        if (!autoSave) {
          this.continue();
        } else {
          this.continue(true);
        }
      }
    },
    addTelehealthVisit(telehealthVisitObj, autoSave = false) {
      nprogress.start();
      const schedulerObj = telehealthVisitObj.schedulerObj;
      telehealthVisitObj.telehelathVisitObj.allowRecording = schedulerObj.type == "onDemand" ? false : telehealthVisitObj.telehelathVisitObj.allowRecording;
      const telehelathVisitedObj = telehealthVisitObj.telehelathVisitObj;
      const postParam = {};
      postParam.telehealthVisitDTO = telehelathVisitedObj;
      postParam.scheduler = schedulerObj;
      postParam.telehealthVisitDTO.version = parseInt(postParam.telehealthVisitDTO.version); // handle version for id : TUR-12741
      // BE dont support string
      if (telehealthVisitObj.telehelathVisitObj.id === undefined) {
        this.createVisit(this.studyId, postParam, autoSave);
      } else {
        this.updateVisit(this.studyId, postParam.telehealthVisitDTO.id, postParam, autoSave);
      }
    },
    updateVisit(studyId, visitId, postParam, autoSave = false) {
      const comparePostParam = JSON.parse(JSON.stringify(postParam));
      delete comparePostParam.telehealthVisitDTO.version;
      if (comparePostParam.telehealthVisitDTO.extendWindow == "") {
        comparePostParam.telehealthVisitDTO.extendWindow = 0;
      }
      if (postParam.scheduler.type === "milestone") {
        postParam.scheduler.frequency = { days: null, title: null, type: null };
        postParam.scheduler.duration = [{ endDay: null, startDay: null }];
        postParam.scheduler.completionWindow = null;
      } else {
        postParam.scheduler.milestones = [];
        postParam.scheduler.completionWindows = {};
      }
      const compareTelehealthVisitDTODifference = this.getObjectDiff(this.getPreviouslySavedData.telehealthVisitDTO, comparePostParam.telehealthVisitDTO);
      const compareSchedulerDifference = this.getObjectDiff(this.getPreviouslySavedData.scheduler, comparePostParam.scheduler);
      const getIsScheduleChangeFlag = this.checkForIsScheduleChange(compareTelehealthVisitDTODifference, compareSchedulerDifference);
      this.$api.updateTeleHealthVisitFact(studyId, visitId, postParam, getIsScheduleChangeFlag).then(
        () => {
          if (!autoSave) {
            toastr.success("Scheduling completed successfully");
          }
          this.addEditDone();
          nprogress.done();
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
          }
          nprogress.done();
        }
      );
    },
    createVisit(studyId, postParam, autoSave = false) {
      this.$api.postTeleHealthVisitFact(studyId, postParam).then(
        () => {
          if (!autoSave) {
            toastr.success("Scheduling completed successfully");
          }
          this.addEditDone();
          nprogress.done();
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
          }
          nprogress.done();
        }
      );
    },
    continue(autoSave = false) {
      const selectedFeatures = this.$store.getters.getSelectedFeatures;
      const featureIndex = _.findIndex(selectedFeatures, ["route", this.$route.name]);
      if (!autoSave) {
        if (featureIndex === selectedFeatures.length - 1) {
          this.$router.push({ name: "features-library-final" });
        } else {
          this.$router.push({
            name: selectedFeatures[featureIndex + 1].route,
            params: { studyId: this.studyId }
          });
        }
      }
    },
    getCountrySpecificStudyFeatures() {
      this.$api.getCountrySpecificStudyFeatures(this.studyId).then(
        response => {
          this.countrySpecificStudyFeatures = response.body;
          const THEnabledCountries = _.filter(this.countrySpecificStudyFeatures, ["isTelehealthEnabled", true]);
          if (THEnabledCountries.length > 0) {
            this.isTelehealthRecordingFeature = THEnabledCountries[0].isTelehealthEnabled;
            this.THvisitRecordingState.studyLevel = THEnabledCountries[0].studyTelehealthRecordingEnabled;
            this.THvisitRecordingState.visitLevel = THEnabledCountries[0].visitTelehealthRecordingEnabled;
          }
          this.countrySpecificStudyFeatures.forEach(() => {
            if (
              _.filter(this.countrySpecificStudyFeatures, {
                isTelehealthRecordingFeature: false,
                isTelehealthEnabled: true
              }).length > 0
            ) {
              this.isAllowedInAllCountry = false;
            } else {
              this.isAllowedInAllCountry = true;
            }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting country specific telehealth status");
        }
      );
    },
    updateCountrySpecificStudyFeatures() {
      this.countrySpecificStudyFeatures.forEach(c => {
        c.studyTelehealthRecordingEnabled = c.isTelehealthEnabled ? this.THvisitRecordingState.studyLevel : false;
        c.visitTelehealthRecordingEnabled = c.isTelehealthEnabled ? this.THvisitRecordingState.visitLevel : false;
      });
      this.$api.updateCountrySpecificStudyFeatures(this.studyId, this.countrySpecificStudyFeatures).then(
        () => {},
        error => {
          toastr.error(error.body ? error.body.message : "Error while updating country specific telehealth status");
        }
      );
    },
    mutualExclusive(prop) {
      this.isAllowedInAllCountry = true;
      for (const p in this.THvisitRecordingState) {
        if (prop == p) {
          this.THvisitRecordingState[p] = this.THvisitRecordingState[p];
        } else {
          this.THvisitRecordingState[p] = false;
        }
      }
      this.countrySpecificStudyFeatures.forEach(c => {
        if (this.isAllowedInAllCountry) {
          c.isTelehealthRecordingFeature = true;
        } else {
          c.isTelehealthRecordingFeature = false;
        }
      });
    },
    getObjectDiff(obj1, obj2) {
      const diff = Object.keys(obj1).reduce((result, key) => {
        if (!obj2.hasOwnProperty(key)) {
          result.push(key);
        } else if (_.isEqual(obj1[key], obj2[key])) {
          const resultKeyIndex = result.indexOf(key);
          result.splice(resultKeyIndex, 1);
        }
        return result;
      }, Object.keys(obj2));
      return diff;
    },
    checkForIsScheduleChange(TelehealthVisitDTODifference, SchedulerDifference) {
      let isScheduleFlag = true;
      if (TelehealthVisitDTODifference.length === 1 && (TelehealthVisitDTODifference.includes("title") || TelehealthVisitDTODifference.includes("activityName"))) {
        isScheduleFlag = false;
      } else if (TelehealthVisitDTODifference.length === 2) {
        if (TelehealthVisitDTODifference[0] === "title" && TelehealthVisitDTODifference[1] === "activityName") {
          isScheduleFlag = false;
        } else if (TelehealthVisitDTODifference[0] === "activityName" && TelehealthVisitDTODifference[1] === "title") {
          isScheduleFlag = false;
        }
      }
      let compareScheduleDifference = SchedulerDifference;
      if (compareScheduleDifference.length === 1 && compareScheduleDifference.includes("taskId")) {
        compareScheduleDifference = [];
      }
      if (compareScheduleDifference.length === 2 && compareScheduleDifference.includes("taskId") && compareScheduleDifference.includes("dynamicScheduling")) {
        compareScheduleDifference = [];
      }
      if (compareScheduleDifference.length === 2 && compareScheduleDifference.includes("taskId") && compareScheduleDifference.includes("completionWindow")) {
        compareScheduleDifference = [];
      }
      if (compareScheduleDifference.length === 1 && (compareScheduleDifference.includes("taskTitle") || compareScheduleDifference.includes("siteTaskCallReminders"))) {
        isScheduleFlag = false;
      }
      if (TelehealthVisitDTODifference.length === 0 && compareScheduleDifference.length === 0) {
        isScheduleFlag = false;
      }
      return isScheduleFlag;
    },
    toggleTHRecordingSettings() {
      const thEnabledCountries = this.countrySpecificStudyFeatures.filter(el => {
        return el.isTelehealthEnabled == true;
      });
      if (thEnabledCountries.length == 0) {
        this.isTelehealthRecordingFeature = false;
      } else {
        this.isTelehealthRecordingFeature = true;
      }
      this.countrySpecificStudyFeatures.forEach(c => {
        if (!c.isTelehealthEnabled) {
          c.isTelehealthRecordingFeature = false;
        }
      });
    },
    SiteTaskprocessOccurranceStringAndCount(notificationArr) {
      let occurranceList = [];
      let telehealthReminders = [];
      const that = this;
      for (let i = 0; i < notificationArr.length; i++) {
        let list = null;
        occurranceList = [];
        telehealthReminders = [];
        list = notificationArr[i].day[0].occur;
        for (let j = 0; j < list.length; j++) {
          let v = 0;
          const time = list[j].timeMinutes;
          const value = time;
          if (list[j].timeMinutes === -2880) {
            v = "b-2-d";
          } else if (list[j].timeMinutes === -14400) {
            v = "b-10-d";
          } else if (list[j].timeMinutes === -7200) {
            v = "b-5-d";
          } else if (list[j].timeMinutes === -10080) {
            v = "b-7-d";
          } else if (list[j].timeMinutes === -1440) {
            v = "b-1-d";
          } else if (list[j].timeMinutes === -120) {
            v = "b-2-h";
          } else if (list[j].timeMinutes === -60) {
            v = "b-1-h";
          } else if (list[j].timeMinutes === -45) {
            v = "b-45-m";
          } else if (list[j].timeMinutes === -60) {
            v = "b-1-h";
          } else if (list[j].timeMinutes === 0) {
            v = 0;
          } else {
            v = list[j].timeMinutes != 0 ? (list[j].when == "afterApptNotJoined" ? "a-" + value : "b-" + -value) : 0;
          }
          const eventOptions = that.eventOptionTypes[2];
          eventOptions.filter(k => {
            if (v == k.value) {
              telehealthReminders.push({
                text: k.text,
                value: value,
                smsToggle: list[j].smsToggle ? list[j].smsToggle : false,
                emailToggle: list[j].emailToggle ? list[j].emailToggle : false
              });

              occurranceList.push({
                text: k.text,
                value: k.value,
                delayType: k.delayType,
                smsToggle: list[j].smsToggle ? list[j].smsToggle : false,
                emailToggle: list[j].emailToggle ? list[j].emailToggle : false
              });
            }
          });
        }
        notificationArr[i].telehealthReminders = telehealthReminders;
        notificationArr[i].occurranceList = occurranceList;
      }
      return notificationArr;
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        if ((Date.now() >= (Number(this.autoSaveElementTimeout) + window.document.getIdleSecondsCounter())) && this.isTHSchedulerAutoSaveEnable) {
          this.restartAutoSave(window.document.getIdleSecondsCounter());
          this.validateScheduler(true);
        }
      }, 1000);
    },
    restartAutoSave(autoSaveTimer = 0) {
      this.stopAutoSave();
      this.autoSaveTimer = setInterval(() => {
        if ((autoSaveTimer < window.document.getIdleSecondsCounter()) && this.isTHSchedulerAutoSaveEnable) {
          this.stopAutoSave();
          this.startAutoSave();
        }
      }, 1000);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.validateScheduler(true);
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>
<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h4,
h4 {
  font-size: 18px;
  margin: 10px 0;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

/deep/ .col {
  padding: 0px !important;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.color_959fa4 {
  color: #959fa4 !important;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-10 {
    width: 82.33333333%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}
.scheduler-heading {
  font-weight: 600;
  color: #666769;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.form-control {
  border-radius: 2px;
}
.bg-none {
  background: none !important;
  outline: none !important;
  border: 1px solid #d3dfe4;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.country_image {
  max-width: 25px;
}

.selected_country_image {
  width: 30px;
}

.code_style {
  border-radius: 2px !important;
  border: 1px solid #ced4da;
  min-width: 70px;
  background-color: #ffffff;
}

.color_666669 {
  color: #666669;
}

.dropdown-menu {
  overflow-y: scroll;
  height: 280px;
  z-index: 98;
  width: 500px;
}

.input-width {
  width: 430px;
  padding-left: 10px;
}

// New CSS
.visit-container {
  font-family: Lato-Regular;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;

  .noVisists {
    color: #b0bac9;
    font-weight: bold;
  }

  .edit-icon {
    margin-left: 20px;
    cursor: pointer;
  }

  .schedulerSection {
    background: #ffffff;
    //border-radius: 4px;
    //border: solid 1px #e4e8eb;
    padding: 20px 21px;
  }

  button {
    &.btn-outline-primary {
      border-color: #1e8fe1;
      color: #1e8fe1;
      &:hover {
        color: #ffffff;
        background-color: #1e8fe1;
      }
    }
  }

  .boldBtn {
    font-weight: bold;
  }
  .col-sm-5,
  .col-sm-2,
  .col-lg-5,
  .col-lg-6,
  .col-lg-1 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .visit-recording {
    & .disabled {
      opacity: 0.4;
    }
    & .checkbox {
      width: 1rem;
      height: 1rem;
      margin-right: 7px;
      display: inline-block;
    }
    & .control-label {
      padding-left: 6px;
      height: 16px;
      vertical-align: middle;
    }
    & .control-label::before,
    .control-label::after {
      top: 0.8rem;
      width: 1rem;
      height: 1rem;
    }
  }
  .p-r {
    position: relative;
    bottom: 3px;
  }
  .img-wrap {
    display: inline-block;
    width: 14px;
    height: 14px;
    img {
      width: 100%;
    }
  }
}
.link {
  font-weight: bold;
  text-align: right;
  color: #1e8fe1;
  cursor: pointer;
}

.countries-toggle {
  label {
    margin-bottom: 0.5625rem;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 20px;

    input {
      display: none;
    }

    /* The slider */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: -2px;
      bottom: 0;
      border: 2px solid #ccc;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 12px;
      width: 12px;
      left: 2px;
      bottom: 2px;
      background-color: #ccc;
    }

    input:checked + .slider {
      border: 2px solid #48bf7a;
    }

    input:checked + .slider:before {
      content: "";
      background-color: #48bf7a;
    }

    input:focus + .slider {
      box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
      /*content: '✓';*/
      position: absolute;
      color: #2ecc71;
      text-align: center;
      font-size: 20px;
      -webkit-transform: translateX(14px);
      -ms-transform: translateX(14px);
      transform: translateX(14px);
    }

    /* Rounded sliders */
    .slider.round {
      border-radius: 32px;
    }

    .slider.round:before {
      border-radius: 50%;
    }

    .country-name {
      margin-left: 48px;
      font-size: 16px;
      font-weight: bold;
      color: #666669;
      cursor: pointer;
      position: absolute;
      padding-top: 3px;
      white-space: nowrap;
    }
  }
}

body.ie .countries-toggle .switch .country-name {
  padding-top: 4px;
}
.country-recording {
  .card {
    width: 57rem;
  }
  .country-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
  }
  .country-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 10rem !important;
  }
  .disabled {
    opacity: 0.4;
  }
  .radio {
    width: 1rem;
    height: 1rem;
    margin-right: 7px;
    display: inline-block;
  }
  .checkbox {
    width: 1rem;
    height: 1rem;
    margin-right: 7px;
    display: inline-block;
  }
  .checkbox-colour {
    color: #666669;
  }
  .control-label {
    padding-left: 6px;
    height: 16px;
    vertical-align: middle;
  }
  .control-label::before,
  .control-label::after {
    top: 0.8rem;
    width: 1rem;
    height: 1rem;
  }
}
</style>
